module.exports = __webpack_public_path__ + "assets/retina_TangentDetailed.c1b35086695bd4995e3148e17f0a5561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TangentDetailed.png
// module id = 738
// module chunks = 0